import client from "../graphqlClient";
import { getGraphqlResult } from "../../Utilities/Functions";
import { GET_LIST_VALUES } from "./graphql";

const getListValues = async (params) => {
  const { listId, listName, listType } = params;
  const response = await client.query({
    query: GET_LIST_VALUES,
    variables: {
      listId,
      listName,
      listType,
    },
    fetchPolicy: "no-cache",
  });
  const results = await getGraphqlResult(response, "getListValues");
  return results;
};

export { getListValues };
